import React from 'react'

const EXPAND_ON_DRAG_OVER_DELAY = 800

export default function useOnLongDragOver({
  isDragOver,
  enable,
  onLongDragOver,
  delay = EXPAND_ON_DRAG_OVER_DELAY,
}) {
  const expandOnDragOverTimeoutHandle = React.useRef()

  React.useEffect(
    () => {
      if (isDragOver) {
        if (!expandOnDragOverTimeoutHandle.current && enable) {
          expandOnDragOverTimeoutHandle.current = setTimeout(() => {
            expandOnDragOverTimeoutHandle.current = null
            onLongDragOver()
          }, delay)
        }
      } else {
        if (expandOnDragOverTimeoutHandle.current) {
          clearTimeout(expandOnDragOverTimeoutHandle.current)
          expandOnDragOverTimeoutHandle.current = null
        }
      }
    },
    [isDragOver, enable, onLongDragOver, delay]
  )
}
